import React, { useEffect } from "react";
import axios from "axios"; // Import axios for API requests
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

// Home pages
import About from "./pages/home/About";
import Agents from "./pages/home/Agents";
import Agent from "./pages/home/Agent";
import ReportArchive from "./pages/home/ReportArchive";
import MarketReportList from "./pages/home/MarketReportList";
import Buyers from "./pages/home/Buyers";
import Sellers from "./pages/home/Sellers";
import SalesFaq from "./pages/home/SalesFaq";
import RentalsFaq from "./pages/home/RentalsFaq";
import Sales from "./pages/home/Sales";
import Rentals from "./pages/home/Rentals";
import SearchNyc from "./pages/home/SearchNyc";
import Property from "./pages/home/Property";
import Press from "./pages/home/Press";
import PressArchive from "./pages/home/PressArchive";
import EstateSolutions from "./pages/home/EstateSolutions";
import International from "./pages/home/International";
import PropertyManagement from "./pages/home/PropertyManagement";
import CorporateRelocation from "./pages/home/CorporateRelocation";
import Architecture from "./pages/home/Architecture";
import MarketReport from "./pages/home/MarketReport";
import Page404 from "./pages/others/Page404";
import Privacy from "./pages/others/Privacy";

// Elements
import Tabs from "./pages/elements/Tabs";
import Accordions from "./pages/elements/Accordions";
import ProgressBars from "./pages/elements/ProgressBars";
import ContactForms from "./pages/elements/ContactForms";
import ThemeIcons from "./pages/elements/ThemeIcons";
import BoxedIcons from "./pages/elements/BoxedIcons";
import GridColumns from "./pages/elements/GridColumns";
import TeamMembers from "./pages/elements/TeamMembers";
import Countdowns from "./pages/elements/Countdowns";
import ScrollToTop from "./helpers/ScrollToTop";

function App() {
  // useEffect(() => {
  //   const fetchJWT = async () => {
  //     try {
  //       // Query the API to get a JWT
  //       const API_URL = `${process.env.REACT_APP_API_BASE_URL}/get-jwt.php`; 
  //       const response = await axios.get(API_URL); 
  //       const { token } = response.data; 

  //       if (token) {
  //         localStorage.setItem("jwtToken", token);
  //         console.log("JWT saved to localStorage:", token);
  //       } else {
  //         console.error("No token received from API");
  //       }
  //     } catch (error) {
  //       console.error("Error fetching JWT from API:", error.message);
  //     }
  //   };

  //   fetchJWT(); 
  // }, []);

  return (
    <Router>
      <ScrollToTop>
        <Switch>
          <Route exact path={`/`} component={Architecture} />
          <Route exact path={`/index.html`} component={Architecture} />
          <Route exact path={`/home`} component={Architecture} />
          <Route exact path={`/rentals-faq`} component={RentalsFaq} />
          <Route exact path={`/sales-faq`} component={SalesFaq} />
          <Route exact path={`/agents`} component={Agents} />
          <Route path={"/agent/:id"} component={Agent} />
          <Route exact path={`/sales`} component={Sales} />
          <Route exact path={`/rentals`} component={Rentals} />
          <Route exact path={`/market-report`} component={MarketReport} />
          <Route exact path={`/market-report-list`} component={MarketReportList} />
          <Route path={`/market-report-archive/:id`} component={ReportArchive} />
          <Route exact path={`/about`} component={About} />
          <Route exact path={`/buyers`} component={Buyers} />
          <Route exact path={`/sellers`} component={Sellers} />
          <Route exact path={`/search`} component={SearchNyc} />
          <Route exact path={`/estate-solutions`} component={EstateSolutions} />
          <Route exact path={`/property-management`} component={PropertyManagement} />
          <Route exact path={`/international`} component={International} />
          <Route exact path={`/corporate-relocation`} component={CorporateRelocation} />
          <Route exact path={`/404-page`} component={Page404} />
          <Route exact path={`/privacy`} component={Privacy} />
          <Route exact path={`/property/:id`} component={Property} />
          <Route exact path={`/press`} component={Press} />
          <Route exact path={`/press-archive`} component={PressArchive} />
          <Route exact path={`/tabs`} component={Tabs} />
          <Route exact path={`/accordions`} component={Accordions} />
          <Route exact path={`/progress-bar`} component={ProgressBars} />
          <Route exact path={`/contact-form`} component={ContactForms} />
          <Route exact path={`/theme-icons`} component={ThemeIcons} />
          <Route exact path={`/boxed-icons`} component={BoxedIcons} />
          <Route exact path={`/grid-columns`} component={GridColumns} />
          <Route exact path={`/team-member`} component={TeamMembers} />
          <Route exact path={`/countdowns`} component={Countdowns} />
          <Route component={Page404} /> {/* Catch-all 404 route */}
        </Switch>
      </ScrollToTop>
    </Router>
  );
}

export default App;
